module.exports = __webpack_public_path__ + "img/finance.bb890abe.svg";